module.exports = __webpack_public_path__ + "static/media/global-shoppng-22.874a7d09.png";